<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 시설물 안전 계획 -->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 시설물 안전 계획</h5>
      </vs-col>
      <div class="w-full grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text">시설물 안전 인력 조직도</div>
          <p v-if="isPrint" class="print-input">
            {{ form.inputA_1.fileName }}
          </p>
          <file-uploader :readonly="board.readonly" v-else v-model="form.inputA_1" class="w-full flex-1" />
        </div>
      </div>
    </vs-row>

    <!-- 정기안전점검 계획 일자 -->
    <vs-row class="mt-8">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 시설물 안전 인력</h5>
      </vs-col>
      <div class="w-full grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text">부서 담당자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <vs-input v-else :readonly="board.readonly" v-model="form.inputB_1" class="w-full flex-1" ></vs-input>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text">부서 연락처</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <vs-input v-else :readonly="board.readonly" v-model="form.inputB_2" class="w-full flex-1" ></vs-input>
        </div>
      </div>
      <div class="w-full grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text">시설 점검자명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>
          <vs-input v-else :readonly="board.readonly" v-model="form.inputB_3" class="w-full flex-1" ></vs-input>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text">점검자 연락처</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
          <vs-input v-else :readonly="board.readonly" v-model="form.inputB_4" class="w-full flex-1" ></vs-input>
        </div>
      </div>
      <div class="w-full grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-12 flex items-center">
          <div class="label-text">기타 안전 인력</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
          <vs-input v-else :readonly="board.readonly" v-model="form.inputB_5" class="w-full flex-1" ></vs-input>
        </div>
      </div>
    </vs-row>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-8" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploader from "@/components/FileUploader.vue";
import DateSelector from "@/components/selector/DateSelector.vue";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    DateSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        inputA_1: {},
        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.label-text {
  width: 114px;
  min-width: 114px;
  font-weight: 500;
  font-size: 14px;
  margin-right: 20px;
}
</style>
